import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Cookies from 'js-cookie'
import ElementUI from "element-ui";
import i18n from './lang' // internationalization
import "element-ui/lib/theme-chalk/index.css";
// import locale from "element-ui/lib/locale/lang/zh-CN";
import "./styles/reset.css"
import http from "./api/index"
import "./components/index"
import 'amfe-flexible';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css';

Vue.use(VueAwesomeSwiper)

import '@/permission'

Vue.prototype.$Http = http;

Vue.use(ElementUI, {
	// locale
	size: Cookies.get('size') || 'medium', // set element-ui default size
	i18n: (key, value) => i18n.t(key, value)
});


Vue.config.productionTip = false;

//解决跳转到页面后，不从头部开始
router.afterEach(() => {
	window.scrollTo(0, 0);
})


new Vue({
	router,
	store,
	i18n,
	render: h => h(App)
}).$mount("#app");
